// The day/night scene is drawn at random once per browser session and shared
// by the homepage and the module workbenches, so the mood stays the same from
// the hero into Grimoire/Sigil. sessionStorage keeps it across reloads and
// route changes in the tab; the module copy keeps it stable when storage is
// blocked.
const STORAGE_KEY = 'jolymei.scene';
export const SCENES = ['day', 'night'];

// The homepage background for each scene.
export const SCENE_IMAGES = {
  day: { hero: '/images/jolymei-scene-day-v1.webp' },
  night: { hero: '/images/jolymei-scene-night-v1.webp' },
};

let sessionScene = null;

export const getScene = () => {
  if (sessionScene) return sessionScene;
  try {
    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (SCENES.includes(stored)) {
      sessionScene = stored;
      return sessionScene;
    }
  } catch {
    // Private mode / blocked storage — fall through to a fresh draw.
  }
  sessionScene = SCENES[Math.floor(Math.random() * SCENES.length)];
  try {
    sessionStorage.setItem(STORAGE_KEY, sessionScene);
  } catch {
    // Keeping it in memory is enough for this page load.
  }
  return sessionScene;
};

// Marks <html> with the scene before the first render, so brand surfaces that
// live outside the homepage and workbenches (auth modal, legal pages, cookie
// notice) take their scene colours from brandSurfaces.css without a flash.
export const applySceneToDocument = () => {
  document.documentElement.dataset.scene = getScene();
};
